var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.5;fill:#FFFFFF;enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    transform: "translate(43.574 405.091) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2117",
    className: "st0",
    d: "M-442.7-84.2c0.8-13.3,12.2-23.5,25.6-22.7h128v51.2h-102.4v409.4h102.4V405h-127.7 c-1.1,0.1-2.2,0.1-3.3,0c-13.3-0.9-23.4-12.4-22.5-25.8V-81.1C-442.8-82.1-442.8-83.1-442.7-84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2118",
    className: "st1",
    d: "M-144.2,2.3c-9.9-9.4-25.6-9-35,0.8l-127.9,127.9c-0.3,0.3-0.6,0.6-0.8,0.8 c-9.4,9.9-9,25.6,0.8,35l127.9,128c9.8,9.2,25,9.2,34.7,0c10.2-9.6,10.7-25.6,1.1-35.8l-84.4-84.1H-7.9c1.1,0.1,2.2,0.1,3.3,0 c13.3-0.9,23.4-12.4,22.5-25.8c0.1-1.1,0.1-2.2,0-3.3c-0.9-13.3-12.4-23.4-25.8-22.5h-219.9l84.4-84.4c0.3-0.3,0.6-0.6,0.8-0.8 c9.4-9.9,9-25.6-0.8-35C-143.6,2.9-143.9,2.6-144.2,2.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.9f59f2e905990dea4b80b85fe17b196c.svg";
export { ForwardRef as ReactComponent };